import ReactHtmlParser from 'react-html-parser';
import { Mutex, withTimeout } from 'async-mutex';
import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';
import * as Popups from '../../constants/popup-types';
import { UpsalePopupStatus } from '../../app/enums';
import { getUpsalePopupStatus, createAnalyticsItemsList, reactParserCommonOptions } from '../../app/functions';

/* actions */
import * as Actions from '../../redux/actions';

const ACQUIRE_PAID_COUPON_COOLDOWN_MS = 10000;
const mutex = withTimeout(new Mutex(), ACQUIRE_PAID_COUPON_COOLDOWN_MS);
class AcquirePaidCouponRequest extends baseRequest {

    constructor(onPurchaseResponse, onAnyResponse, benefit = null, translations = {}, onClose = null) {
        super();
        this.payload            = {};
        this.dispatch           = null;
        this.response           = null;
        this.name               = 'AcquirePaidCouponRequest';
        this.Config             = new AppConfig();
        this.onPurchaseResponse = onPurchaseResponse;
        this.onAnyResponse      = onAnyResponse;
        this.benefit            = benefit;
        this.translations       = translations;
        this.onClose            = onClose;
    }

    async execute(dispatch, payload) {
        this.payload = payload;
        this.dispatch = dispatch;
       if(await mutex.isLocked()) {
        return;
       }

        mutex
        .acquire()
        .then(() => {
            this.call(this.Config.api.requests.acquirePaidCoupon, payload);
        }).catch(() => {
            console.log('AcquirePaidCouponRequest is already in progress');
        });
    }

    onSuccess() {
        mutex.release();
        this.updateState();
    }

    updateState() {
        mutex.release();
        this.onPurchaseResponse(this.response.data);
        this.onAnyResponse();
        this.dispatch(Actions.setCouponPayResult(this.response.data));
    }

    onFailure() {
        mutex.release();
        this.onAnyResponse();
        AnalyticsManager.logBenefitPaidCouponFailed(this.payload?.benefitId);
        
        if (this.onClose) {
            this.onClose();
        }
        
        const err = this.response.err;
        
        if (this.benefit?.is_subsidized) {
            const status = getUpsalePopupStatus(err.status);
            AnalyticsManager.logUpsalePopupPresented(status);
            const itemsList = createAnalyticsItemsList(this.benefit.relatedBenefits, {
                item_list_name: 'upsale_popup'
            });

            AnalyticsManager.logUpsalePopupViewedItemList(itemsList);

            this.dispatchSubsidyPopup(
                err.content, 
                status,
                this.benefit,
            );
        } else {
            if (this.benefit?.relatedBenefits) {
                this.dispatchSubsidyPopup(
                    err.content || this.translations['upsell_popup_purchase_error_title'],
                    UpsalePopupStatus.NO_INVENTORY,
                    this.benefit,
                );
            } else {
                this.dispatch(Actions.addPopup({
                    type: Popups.GENERAL_MESSAGE,
                    text: ReactHtmlParser(err.content, reactParserCommonOptions()),
                }));
            }
        }
    }

    dispatchSubsidyPopup(content, status, benefit) {
        const { relatedBenefits, main: { title, upsell_popup_footer_text } } = benefit;
        this.dispatch(Actions.addPopup({
            type: Popups.SUBSIDY_POPUP,
            content,
            header: title,
            benefits: relatedBenefits,
            status,
            footerText: upsell_popup_footer_text
        }));
    }
}

export default AcquirePaidCouponRequest;
